//This needs to be a global to allow the recaptcha script from google to access it
function recaptchaResponse(token) {
    $("#recaptchaToken").val(token);
}

(function () {
  $(document).ready(function () {
    $("#newsletterSignupForm").submit(function (event) {
      event.preventDefault();
      submitNewsletterSignup();
    });
  });

  function submitNewsletterSignup() {
    Utility.showLoadingModal();
    
    $.ajax({
        type: 'POST',
        url: 'https://api.meyernaturalfoods.com/api/v1/newsletter/submit',
        datatype: "json",
        data: JSON.stringify({
            email: $("#newsletterSignup_Email").val(),
            firstName: $("#newsletterSignup_FirstName").val(),
            lastName: $("#newsletterSignup_LastName").val(),
            postalCode: $("#newsletterSignup_ZipCode").val(),
            recaptchaToken: $("#recaptchaToken").val()
        }),
        contentType: "application/json; charset=utf-8"
    }).done(function (data) {
        if (typeof data.success !== "undefined" && data.success === true) {
          $("#newsletterSignupMessage").text("Thank you for signing up for the Meyer Natural newsletter.  You should receive an email with information on how to confirm your email.").removeClass("hidden");
            document.getElementById("newsletterSignupMessage").classList.remove("error");
            document.getElementById("newsletterSignupForm").classList.add("hidden");
            ga('send', {
              hitType: 'event',
              eventCategory: 'newsletter',
              eventLabel: window.location.href
            });
        }
        else {
            Utility.displayMessage("error", "#newsletterSignupMessage", Object.entries(data.errors).map((item) => item[1]).join("<br>"));
            //$("#newsletterSignupMessage").text(data.error).removeClass("hidden");
            //document.getElementById("newsletterSignupMessage").classList.add("error");
        }
    }).fail(function (data) {
      if (typeof data.responseJSON.errors !== "undefined"){
        Utility.displayMessage("error", "#newsletterSignupMessage", Object.entries(data.responseJSON.errors).map((item) => item[1]).join("<br>"));
      }
      else{
        Utility.displayMessage("error", "#newsletterSignupMessage", "Sorry for the inconvenience, but an error has occurred.  Please reload the page and try again.");  
      }
    }).always(function () {
        Utility.hideLoadingModal();
    });
}
})();